module.exports = __webpack_public_path__ + "assets/amex-1d24f4.svg";